import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  templateUrl: 'header-wrapper.component.html',
  styleUrls: ['header-wrapper.component.scss'],
  imports: [],
})
export class HeaderWrapperComponent extends FieldWrapper {}
